import Vue from "vue";
import VueRouter from "vue-router";
import sessionStorageUtils from "@/utils/session-storage";
import { CommonClass } from "@/mixins";
Vue.use(VueRouter);

export const urlContants = {
  loginUrl: "/login",
  registerUrl: "/register",
};
/* eslint-disable */
let memberIdRequestID = document.cookie.replace(
  /(?:(?:^|.*;\s*)MEMBERID-REQUEST-ID\s*\=\s*([^;]*).*$)|^.*$/,
  "$1"
);

export function clearMemberIdRequestID() {
  memberIdRequestID = "";
}

function isAuthenticated() {
  const requestID = sessionStorageUtils.getItem("requestID");
  const loggedIn = sessionStorageUtils.getItem("loggedIn");
  if (requestID && loggedIn && !memberIdRequestID) {
    return true;
  } else {
    return false;
  }
}

function setChannelId() {
  const channelId = CommonClass.methods.$__checkChannelId()
  sessionStorageUtils.setItem("ChannelId", channelId);
  return channelId
}

function populatePageTitle(isDesktopChannel, to, from, moduleName) {
  let screenName = to?.meta?.screenName;
  if (!screenName) {
      return 'n/a';
  }

  if (from?.name === 'ForgotPassword') {
      const forgotPasswordMapping = {
          'Sign In_Mobile OTP': 'Forgot Password_Mobile OTP',
          'Sign In_Email OTP': 'Forgot Password_Email OTP'
      };
      screenName = forgotPasswordMapping[screenName] || screenName;
  }

  if (isDesktopChannel) {
      const screenNameMap = {
          'Sign In_Enter Password': 'Sign In',
          'Forgot Password': 'Reset Password',
          'Forgot Password_Set New Password': 'Reset Password_Set New Password',
          'Forgot Password_Success': 'Reset Password_Success',
          'Forgot Password_Mobile OTP': 'Reset Password_Mobile OTP',
          'Forgot Password_Email OTP': 'Reset Password_Email OTP'
      };
      screenName = screenNameMap[screenName] || screenName;
  }

  return `${isDesktopChannel ? 'MO_' : ''}${moduleName}_${screenName}`;
}

// Array of paths to redirect to login if user tries to copy and paste url to new tab
const redirectList = [
  "/sign-up",
  `${urlContants.registerUrl}/mobile-otp-verification`,
  `${urlContants.registerUrl}/email-otp-verification`,
  `${urlContants.registerUrl}/create-account`,
  `${urlContants.registerUrl}/success`,
  `${urlContants.registerUrl}/register-mobile`,
  `${urlContants.loginUrl}/mobile-otp-verification`,
  `${urlContants.loginUrl}/email-otp-verification`,
  `${urlContants.loginUrl}/my-info`,
  `${urlContants.loginUrl}/forgot-password`,
  `${urlContants.loginUrl}/forgot-password/reset`,
  `${urlContants.loginUrl}/delete-account`,
  `${urlContants.loginUrl}/logout`,
  // `${urlContants.loginUrl}/device-info`,
];

let isDesktopChannel;

const routes = [
  {
    path: "/",
    redirect: () => {
      return { path: urlContants.loginUrl };
    },
    meta: {
      title: "Sign In",
    },
  },
  {
    path: urlContants.loginUrl,
    name: "Login",
    component: () => import("@/views/Login"),
    alias: ["/"],
    meta: {
      title: "Sign In",
      screenName: "Sign In_Enter Password",
      moduleName: "Login",
    },
  },
  {
    path: urlContants.loginUrl + "/default-page",
    name: "DefaultPage",
    component: () => import("@/views/default-page/DefaultPage"),
    meta: {
      title: "Sign In",
      screenName: "Sign In_Default Page",
      moduleName: "Login",
    },
  },
  {
    path: urlContants.loginUrl + "/mobile-otp-verification",
    name: "MobileOtp",
    component: () => import("@/views/MobileOtp"),
    meta: {
      title: "Enter OTP",
      screenName: "Sign In_Mobile OTP",
      moduleName: "Login",
    },
  },
  {
    path: urlContants.registerUrl + "/mobile-otp-verification",
    name: "MobileOtpReg",
    component: () => import("@/views/MobileOtp"),
    meta: {
      title: "Enter OTP",
      screenName: "Sign Up_Mobile OTP",
      moduleName: "Onboarding",
    },
  },
  {
    path: urlContants.loginUrl + "/email-otp-verification",
    name: "EmailOtp",
    component: () => import("@/views/EmailOtp"),
    meta: {
      title: "Enter OTP",
      screenName: "Sign In_Email OTP",
      moduleName: "Login",
    },
  },
  {
    path: urlContants.registerUrl + "/email-otp-verification",
    name: "EmailOtpReg",
    component: () => import("@/views/EmailOtp"),
    meta: {
      title: "Enter OTP",
      screenName: "Sign Up_Email OTP",
      moduleName: "Onboarding",
    },
  },
  {
    path: urlContants.registerUrl,
    name: "Verification",
    component: () => import("@/views/policy-verification/Verification"),
    meta: {
      screenName: "Sign Up_Member Verification",
      moduleName: "Onboarding",
    },
  },
  {
    path: urlContants.registerUrl + "/no-policy",
    name: "NoPolicy",
    component: () => import("@/views/policy-verification/NoPolicy"),
  },
  {
    path: urlContants.registerUrl + "/no-gid",
    name: "NoGid",
    component: () => import("@/views/policy-verification/NoGid"),
  },
  {
    path: urlContants.registerUrl + "/existing-member-id",
    name: "ExistingMemberId",
    component: () => import("@/views/policy-verification/ExistingMemberId"),
  },
  {
    path: urlContants.registerUrl + "/create-account",
    name: "CreateAccount",
    component: () => import("@/views/sign-up/CreateAccount"),
    meta: {
      screenName: "Sign Up_Enter Email And Password",
      moduleName: "Onboarding",
    },
  },
  {
    path: urlContants.loginUrl + "/my-info",
    name: "UpdateRecord",
    component: () => import("@/views/my-info/UpdateRecord"),
  },
  {
    path: urlContants.loginUrl + "/my-info/myinfo-record",
    name: "MyinfoRecord",
    component: () => import("@/views/my-info/MyinfoRecord"),
  },
  {
    path: urlContants.loginUrl + "/my-info/mobile-update-success",
    name: "MyinfoMobileUpdateSuccess",
    component: () => import("@/views/my-info/MobileUpdateSuccess"),
  },
  {
    path: "/sign-up/personal-particular",
    name: "PersonalParticular",
    component: () => import("@/views/sign-up/PersonalParticular"),
  },
  {
    path: urlContants.registerUrl + "/existing-email",
    name: "ExistingEmail",
    component: () => import("@/views/sign-up/ExistingEmail"),
  },
  {
    path: urlContants.registerUrl + "/register-mobile",
    name: "RegisterMobile",
    component: () => import("@/views/sign-up/RegisterMobile"),
    meta: {
      screenName: "Sign Up_Enter Mobile",
      moduleName: "Onboarding",
    },
  },
  {
    path: urlContants.registerUrl + "/success",
    name: "Success",
    component: () => import("@/views/sign-up/Success"),
    meta: {
      screenName: "Sign Up_Success",
      moduleName: "Onboarding",
    },
  },
  {
    path: urlContants.loginUrl + "/change-password",
    name: "ChangePassword",
    component: () => import("@/views/change-password/ChangePassword"),
    meta: {
      requiresAuth: true,
      screenName: "Change Password",
      moduleName: "Account",
    },
  },
  {
    path: urlContants.loginUrl + "/change-password/success",
    name: "CPSuccess",
    component: () => import("@/views/change-password/Success"),
    meta: {
      requiresAuth: true,
      screenName: "Change Password_Success",
      moduleName: "Account",
    },
  },
  {
    path: urlContants.loginUrl + "/view-profile",
    name: "UserProfile",
    component: () => import("@/views/user-profile/UserProfile"),
    meta: {
      title: "Profile",
      requiresAuth: false,
    },
  },
  {
    path: urlContants.loginUrl + "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/views/forgot-password/ForgotPassword"),
    meta: {
      screenName: "Forgot Password",
      moduleName: "Login",
    },
  },
  {
    path: urlContants.loginUrl + "/forgot-password/reset",
    name: "ResetPassword",
    component: () => import("@/views/forgot-password/ResetPassword"),
    meta: {
      screenName: "Forgot Password_Set New Password",
      moduleName: "Login",
    },
  },
  {
    path: urlContants.loginUrl + "/forgot-password/success",
    name: "RPSuccess",
    component: () => import("@/views/forgot-password/Success"),
    meta: {
      screenName: "Forgot Password_Success",
      moduleName: "Login",
    },
  },
  {
    path: urlContants.loginUrl + "/delete-account",
    name: "DeleteAccount",
    component: () => import("@/views/delete-account/DeleteAccount"),
  },
  {
    path: urlContants.loginUrl + "/delete-account/feedback",
    name: "FeedBack",
    component: () => import("@/views/delete-account/FeedBack"),
  },
  {
    path: urlContants.loginUrl + "/delete-account/goodbye",
    name: "GoodBye",
    component: () => import("@/views/delete-account/GoodBye"),
  },
  {
    path: urlContants.loginUrl + "/device-info",
    name: "BiometricSetting",
    component: () => import("@/views/fido/BiometricSetting"),
    meta: {
      title: "BiometricSetting",
      requiresAuth: false,
      screenName: "Biometric Setting",
      moduleName: "Account",
    },
  },
  {
    path: "/dummy/login",
    name: "DummyLogin",
    component: () => import("@/views/DummyLogin"),
    meta: {
      title: "Sign In (Dummy)",
    },
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("@/views/error/Error"),
    props: (route) => ({ query: route.query.errCode }),
  },
  {
    path: urlContants.loginUrl + "/error",
    name: "ErrorCode",
    component: () => import("@/views/error/Error"),
    props: (route) => ({ query: route.query.errCode }),
  },
  {
    path: "/error/non-policy-holder",
    name: "NonPolicyHolderError",
    component: () => import("@/views/error/NonPolicyHolderError"),
    props: (route) => ({ query: route.query.errCode }),
  },
  {
    path: urlContants.loginUrl + "/logout",
    name: "Logout",
    component: () => import("@/views/Logout"),
  },
  {
    path: "/developerMode",
    name: "DeveloperMode",
    component: () => import("@/components/shared/developerMode/DeveloperMode"),
  },
  {
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    component: () => import("@/views/PageNotFound"),
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/memberid/",
  routes,
});

//Code for handling browser buttons
let isProgrammaticallyRoute = false;
["push", "replace", "go", "back", "forward"].forEach((methodName) => {
  const method = router[methodName];
  router[methodName] = (...args) => {
    isProgrammaticallyRoute = true;
    method.apply(router, args);
  };
});
// Dynamically change title
router.beforeEach(async (to, from, next) => {
  const initPath = `${window.location.host}`;
  const routerBase = router?.options?.base.replace(/\/$/, '') || '';
  const oldUrl = from?.path ? `${initPath}${routerBase}${from.path}` : 'n/a';
  const newUrl = to?.path ? `${initPath}${routerBase}${to.path}` : 'n/a';
  const channelId = sessionStorageUtils.getItem("ChannelId") || setChannelId();
  isDesktopChannel = CommonClass.methods.$__checkIsDesktopChannel();
  const contentGroup = to?.meta?.moduleName || 'n/a';
  const pageTitle = populatePageTitle(isDesktopChannel, to, from, contentGroup);

  window.dataLayerPush({
      event: 'page_view',
      page_referrer: oldUrl,
      page_location: newUrl,
      page_title: pageTitle,
      content_group: contentGroup
  })

  // change title based on route meta tag
  document.title =
    to.meta.title !== undefined ? `Member ID - ${to.meta.title}` : `Member ID`;
  // remove error/success banner if any on route change
  if (to?.name !== from?.name && router.app?.$store) {
    router.app?.$store?.commit("alert/CLOSE_ALERT");
  }

  // Auth guard
  const requiresAuth = to.matched.some((rec) => rec.meta.requiresAuth);
  if (
    (requiresAuth && !isAuthenticated()) ||
    (from.path == "/" &&
      redirectList?.some((v) => to.path === v) &&
      !memberIdRequestID)
  ) {
    next(`${urlContants.loginUrl}`);
  } else if (
    (to.path == urlContants.loginUrl + "/login" || to.path == "/") &&
    isAuthenticated()
  ) {
    next(`${urlContants.loginUrl}/view-profile`);
  } else if (from.name === null || isProgrammaticallyRoute) {
    next();
  } else {
    next(false);
  }
  isProgrammaticallyRoute = false;
});

export default router;
